export * from './conta-pagar.component';